import { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import WhatsAppWidget from "@/components/WhatsAppWidget";
import Index from "./pages/Index";

const OverMij = lazy(() => import("./pages/OverMij"));
const Diensten = lazy(() => import("./pages/Diensten"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Contact = lazy(() => import("./pages/Contact"));
const Login = lazy(() => import("./pages/Login"));
const Admin = lazy(() => import("./pages/Admin"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Sonner = lazy(() => import("@/components/ui/sonner").then((module) => ({ default: module.Toaster })));

const ToasterGate = () => {
  const location = useLocation();
  const [allowSonner, setAllowSonner] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setAllowSonner(true), 1200);
    return () => window.clearTimeout(timer);
  }, [location.pathname]);

  const needsToasts =
    location.pathname === "/contact" ||
    location.pathname === "/login" ||
    location.pathname.startsWith("/admin");

  if (!needsToasts || !allowSonner) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <Sonner />
    </Suspense>
  );
};

const App = () => {
  return (
    <>
      <BrowserRouter>
        <ToasterGate />
        <WhatsAppWidget />
        <Suspense fallback={<div className="min-h-screen bg-background" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/over-mij" element={<OverMij />} />
            <Route path="/diensten" element={<Diensten />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
};

export default App;
